import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getPromotionItems} from '../../../apis/promotion/item'

/**
 * banner 가져오기 모달 전용 — 특정 프로모션의 item 목록을 지정 language 헤더로 조회.
 * 언어별 item id 가 다르므로 ko/en 을 명시적으로 강제한다. promotionId 없으면 비활성.
 */
const useQueryPromotionItemsByLang = (
    promotionId: string | null,
    language: 'ko' | 'en',
    enabled: boolean = true,
) => {
    const {data, refetch, isLoading} = useQuery({
        enabled: enabled && !!promotionId,
        queryKey: QueryCacheKeys.promotion.getPromotionItems(promotionId || undefined, language),
        queryFn: async () => {
            const {data} = await getPromotionItems(promotionId as string, language)
            return data
        },
        refetchOnWindowFocus: false,
    })
    return {data, refetch, isLoading}
}

export default useQueryPromotionItemsByLang
